import * as Sentry from '@sentry/react-native';
import type { ComponentType } from 'react';

import config from '@config';

class CrashlyticsService {
  init() {
    Sentry.init({
      dsn: config.SENTRY_DSN,
      environment: config.ENV,
      enabled: !__DEV__,
    });
  }

  private _captureException(exception: any) {
    return Sentry.captureException(exception);
  }

  captureException(error: Error | unknown) {
    if (!__DEV__) {
      this._captureException(error);
    } else {
      console.warn('[CUSTOM LOG ERROR]:', error);
    }
  }

  wrap<T extends Record<string, unknown>>(
    RootComponent: ComponentType<T>,
  ) {
    return Sentry.wrap(RootComponent);
  }
}

export default new CrashlyticsService();
